import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=a9a53c14&scoped=true&"
import script from "./PhotoGallery.vue?vue&type=script&lang=ts&"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=a9a53c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a53c14",
  null
  
)

export default component.exports